export const CREATE_PROJECTASSUMPTIONS_REQUEST = 'CREATE_PROJECTASSUMPTIONS_REQUEST';
export const CREATE_PROJECTASSUMPTIONS_SUCCESS = 'CREATE_PROJECTASSUMPTIONS_SUCCESS';
export const CREATE_PROJECTASSUMPTIONS_FAILURE = 'CREATE_PROJECTASSUMPTIONS_FAILURE';

export const FETCH_PROJECTASSUMPTIONS_REQUEST = 'FETCH_PROJECTASSUMPTIONS_REQUEST';
export const FETCH_PROJECTASSUMPTIONS_SUCCESS = 'FETCH_PROJECTASSUMPTIONS_SUCCESS';
export const FETCH_PROJECTASSUMPTIONS_FAILURE = 'FETCH_PROJECTASSUMPTIONS_FAILURE';